import React, { useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Typography,
  Button,
  Tag,
  List,
  Carousel,
  Image,
  Card,
  Divider,
  Tour,
  Spin,
  InputNumber,
  message,
  Select,
  Input,
  Modal,
  Space,
} from "antd";
import {
  CaretLeftOutlined,
  CheckCircleOutlined,
  StarFilled,
  DownloadOutlined,
  LeftOutlined,
  RightOutlined,
  SwapOutlined,
  RotateLeftOutlined,
  RotateRightOutlined,
  ZoomOutOutlined,
  ZoomInOutlined,
  UndoOutlined,
} from "@ant-design/icons";
import axios from "axios";
import ProductDetailSkeleton from "./ProductDetailSkeleton";
import "../../config";
import { WhatsAppOutlined } from "@ant-design/icons"; // Ant Design icon
import { useParams } from "react-router-dom";
import ReactGA from "react-ga4";
import type { TourProps } from "antd";
import "./ProductDetail.css";

const { Title, Text } = Typography;

const ProductDetail = ({
  refreshCartCount,
  productIdQuery: propProductIdQuery,
  isModal,
}) => {
  let { productIdQuery: routeProductIdQuery } = useParams();
  const productIdQuery = propProductIdQuery || routeProductIdQuery;

  const carouselRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [productDet, setProductDet] = useState([]);
  const [loading, setLoading] = useState(true);
  const [associatedContact, setAssociatedContact] = useState("8000002808");
  const [open, setOpen] = useState(false);
  const [showProdStatus, setShowProdStatus] = useState(false);

  const [imageLoading, setImageLoading] = useState(true); // State for image loading

  const [quantity, setQuantity] = useState(1);
  const [selectedSize, setSelectedSize] = useState(""); // Add state for selected size
  const [selectedColor, setSelectedColor] = useState(""); // For color dropdown
  const [userDetail, setUserDetail] = useState("");
  const [colorDropdownOpen, setColorDropdownOpen] = useState(false);
  const [showOrderControls, setShowOrderControls] = useState(false); // New state for showing order controls
  const [loginModalVisible, setLoginModalVisible] = useState(false);

  const [messageApi, contextHolder] = message.useMessage();

  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const ref4 = useRef(null);

  const sizeOptions =
    productDet.Sizes && productDet.Sizes.length > 0
      ? productDet.Sizes
      : ["Free Size"];

  // Color options logic if SellingSingleColor is true
  const colorOptions =
    productDet.SellingSingleColor && productDet.ProductImages
      ? productDet.ProductImages
      : [];

  useEffect(() => {
    window.scrollTo(0, 0);
    setLoading(true);

    // Show login modal if not logged in
    if (!localStorage.getItem("token")) {
      setLoginModalVisible(true);
    } else {
      checkUserActiveStatus();
      getProductDetail();
      setLoading(false);
      logUserActivity();
    }

    if (productDet) {
      document.title = "JOJ | " + productDet.DesignNo;
    }
    if (sizeOptions.length > 0) {
      setSelectedSize(sizeOptions[0]);
    }

    // Set default selected color if SellingSingleColor
    if (productDet.SellingSingleColor && colorOptions.length > 0) {
      setSelectedColor(colorOptions[0].Description);
    }
  }, [productDet.ProductID]);

  useEffect(() => {
    if (
      productDet.ProductImages &&
      productDet.ProductImages.length === 1 &&
      (!productDet.ProductImages[0].Description ||
        productDet.ProductImages[0].Description.trim() === "")
    ) {
      // Set Description as "Mix Color"
      setProductDet((prev) => ({
        ...prev,
        ProductImages: [
          {
            ...prev.ProductImages[0],
            Description: "Mix Color",
          },
        ],
      }));
    }
    // eslint-disable-next-line
  }, [productDet.ProductImages]);

  const steps: TourProps["steps"] = [
    {
      title: "Status of Product",
      description: "Check the status of the product.",
      target: () => ref1.current,
    },
    {
      title: "Box Size",
      description: "MOQ for the Product or Box Size.",
      target: () => ref2.current,
    },
    {
      title: "No Of Colors",
      description: "No of colors available for the product.",
      target: () => ref3.current,
    },
    {
      title: "Confirm Final Availability",
      description:
        "You can Confirm final availability with sales team on Whats App using this Button.",
      target: () => ref4.current,
    },
  ];

  const handleImageLoad = () => {
    setImageLoading(false); // Set to false when the image is fully loaded
  };

  const checkUserActiveStatus = async () => {
    const tokenString = localStorage.getItem("token");

    try {
      let config = {
        method: "get",
        url:
          global.config.APIURL.BaseURL + "api/UserAccount/GetUserAccountDetail",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + tokenString,
        },
      };

      axios
        .request(config)
        .then((response) => {
          setAssociatedContact(response.data.AssoEmpContact);
          setShowProdStatus(response.data.ShowProductStatus);

          // Show order controls only if AllowtoOrder is true
          setShowOrderControls(response.data.AllowtoOrder === true);

          if (
            response.data.IsActive === false ||
            response.data.IsDeleted === false
          ) {
            alert("Your session has expired. Please log in again.");

            localStorage.removeItem("token");
            localStorage.removeItem("userName");
            window.location.reload();
          }
        })
        .catch((error) => {});
    } catch (error) {}
  };

  const logUserActivity = async () => {
    const tokenString = localStorage.getItem("token");
    let ProductID = sessionStorage.getItem("ProductID");
    if (!ProductID) {
      ProductID = productIdQuery;
    }

    try {
      const jsondata = JSON.stringify({
        ScreenID: "3",
        DetailID: ProductID,
      });

      let config = {
        method: "post",
        url: global.config.APIURL.BaseURL + "api/UserActivity/InsertActivity",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + tokenString,
        },
        data: jsondata,
      };

      axios
        .request(config)
        .then((response) => {
          if (response.data === false) {
            const timeout = setTimeout(() => {
              setOpen(true);
            }, 2500);
          }
        })
        .catch((error) => {});
    } catch (err) {}
  };

  async function logTourStatus({ IsCompleted, IsSkip }) {
    const tokenString = localStorage.getItem("token");

    try {
      const jsondata = JSON.stringify({
        ScreenID: "3",
        IsCompleted: IsCompleted,
        IsSkiped: IsSkip,
      });

      let config = {
        method: "post",
        url: global.config.APIURL.BaseURL + "api/UserTour/InsertTourStatus",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + tokenString,
        },
        data: jsondata,
      };

      axios
        .request(config)
        .then((response) => {})
        .catch((error) => {});
    } catch (err) {}
  }

  async function getProductDetail() {
    let ProductID = sessionStorage.getItem("ProductID");
    if (!ProductID) {
      ProductID = productIdQuery;
    }
    if (isModal === true) {
      ProductID = productIdQuery;
    }

    const tokenString = localStorage.getItem("token");

    try {
      let config = {
        method: "get",

        url:
          global.config.APIURL.BaseURL +
          "api/Product/ProductDetailByID?ProdID=" +
          ProductID,
        headers: {
          Authorization: "Bearer " + tokenString,
        },
      };

      axios
        .request(config)
        .then((response) => {
          //console.log(JSON.stringify(response.data));
          console.log("Product Detail Response:", response.data);
          setProductDet(response.data);
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 401) {
              localStorage.removeItem("token");
            }
          }
        });
    } catch (err) {}
    setLoading(false);
  }

  const handleThumbnailClick = (index) => {
    setCurrentSlide(index);
    carouselRef.current?.goTo(index);
  };

  const statusColors = {
    Available: "green",
    "Out of Stock": "orange",
    General: "blue",
  };

  const handleWhatsAppClick = () => {
    const IsEmployee = localStorage.getItem("IsEmployee");

    if (IsEmployee === "false") {
      ReactGA.event({
        category: "Product Detail",
        action: "clicked on ask Quantity",
        label: productDet.DesignNo, // optional
        nonInteraction: false, // optional, true/false
        transport: "xhr", // optional, beacon/xhr/image
      });
    }
    var value = "Please Let me know the availability of " + productDet.DesignNo;
    if (value != "") {
      const encoded = encodeURI(value);
      window.open(
        "https://wa.me/91" + associatedContact + "?text=" + encoded,
        "_blank"
      );
    }
  };

  // Replace your handleAddToCart function with the following:

  const handleAddToCart = async () => {
    const tokenString = localStorage.getItem("token");
    const ProductID = productDet.ProductID;
    const Color = selectedColor;
    const Size =
      typeof selectedSize === "object" ? selectedSize.Size : selectedSize;
    const NoOfBox = quantity;
    const BoxSize = productDet.QtyInBox || 1;
    const TotalQuantity = quantity * BoxSize;
    let Price = productDet.SalesRate;
    if (
      productDet.DealRate &&
      productDet.DealRate > 0 &&
      productDet.DealRate < productDet.SalesRate
    ) {
      Price = productDet.DealRate;
    }
    const Amount = Price * TotalQuantity;
    const Detail = userDetail;

    const payload = {
      ProductID,
      Color,
      Size,
      NoOfBox,
      BoxSize,
      TotalQuantity,
      Price,
      Amount,
      Detail,
      AddedOn: null,
      LastUpdatedOn: null,
    };

    try {
      const response = await axios.post(
        global.config.APIURL.BaseURL + "api/UserCart/AddIntoCart",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + tokenString,
          },
        }
      );

      if (response.status === 200) {
        messageApi.open({
          type: "success",
          content: "Product Added to Cart Successfully",
        });
        setUserDetail("");

        if (refreshCartCount) {
          console.log("insideif");

          refreshCartCount();
        }
      } else {
        messageApi.open({
          type: "error",
          content: "Failed to add to cart.",
        });
      }
    } catch (error) {
      messageApi.open({
        type: "error",
        content: "Failed to add to cart.",
      });
    }
  };

  const downloadImage = async (url, filename) => {
    try {
      // Use fetch with proper CORS handling
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "image/*",
        },
        mode: "no-cors",
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename || "product-image.jpg";
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up
      URL.revokeObjectURL(blobUrl);

      messageApi.open({
        type: "success",
        content: "Image downloaded successfully!",
      });
    } catch (error) {
      console.error("Direct download failed:", error);

      // Show waiting message
      messageApi.open({
        type: "info",
        content:
          "Opening image in new tab...Then long press to save or right click to save.",
      });

      // Wait for 3 seconds then open in new tab
      setTimeout(() => {
        window.open(url, "_blank", "noopener,noreferrer");
        messageApi.open({
          type: "info",
          content: "Image opened in new tab. Right-click to save the image.",
        });
      }, 2000);
    }
  };

  return (
    <>
      {contextHolder}
      {/* Login Modal */}
      <Modal
        open={loginModalVisible}
        onCancel={() => setLoginModalVisible(false)}
        footer={null}
        centered
        closable={false}
        styles={{
          padding: 24,
          textAlign: "center",
        }}
      >
        <h2>Login Now to View Product Details</h2>
        <p style={{ marginBottom: 24 }}>
          Please login to view full product details and pricing.
        </p>
        <Button
          type="primary"
          style={{ width: "100%", marginBottom: 12 }}
          onClick={() => {
            setLoginModalVisible(false);
            window.location.href = "/login";
          }}
        >
          Login Now
        </Button>
        <Button
          style={{ width: "100%" }}
          onClick={() => {
            setLoginModalVisible(false);
            window.history.back(); // Go back to previous list page
          }}
        >
          Close and Back to List
        </Button>
      </Modal>

      {!productDet.ProductID ? (
        <ProductDetailSkeleton />
      ) : (
        <div
          style={{
            paddingLeft: "0px",
            paddingRight: "0px",
            paddingTop: "20px",
          }}
        >
          {/* Hide Back button and Divider if isModal is true */}
          {!isModal && (
            <>
              <Button
                type="primary"
                icon={<CaretLeftOutlined />}
                onClick={() => window.history.back()}
              >
                Back to Product List
              </Button>
              <Divider />
            </>
          )}
          <Row gutter={[32, 32]} justify="center">
            <Col xs={24} md={12}>
              <Image.PreviewGroup
                preview={{
                  toolbarRender: (
                    _,
                    {
                      transform: { scale },
                      actions: {
                        onActive,
                        onFlipY,
                        onFlipX,
                        onRotateLeft,
                        onRotateRight,
                        onZoomOut,
                        onZoomIn,
                        onReset,
                      },
                      current,
                    }
                  ) => (
                    <Space size={12} className="toolbar-wrapper">
                      <LeftOutlined onClick={() => onActive?.(-1)} />
                      <RightOutlined onClick={() => onActive?.(1)} />

                      <ZoomOutOutlined
                        disabled={scale === 1}
                        onClick={onZoomOut}
                      />
                      <ZoomInOutlined
                        disabled={scale === 50}
                        onClick={onZoomIn}
                      />

                      {/* Only show download button if AllowDownload is true */}
                      {productDet.AllowDownload === true && (
                        <div style={{ display: "flex", gap: 8 }}>
                          <Button
                            type="primary"
                            icon={<DownloadOutlined />}
                            onClick={() => {
                              const currentImage =
                                productDet.ProductImages[current];
                              // Use DonwloadImgURL instead of ImageUrl
                              downloadImage(
                                currentImage.DonwloadImgURL,
                                `${productDet.DesignNo}-${current + 1}.jpg`
                              );
                            }}
                          >
                            Download
                          </Button>
                        </div>
                      )}
                    </Space>
                  ),
                }}
              >
                <Carousel
                  ref={carouselRef}
                  dots={false}
                  draggable
                  afterChange={setCurrentSlide}
                >
                  {productDet.ProductImages.map((img, idx) => (
                    <div key={idx} style={{ position: "relative" }}>
                      {imageLoading && (
                        <div
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            zIndex: 1,
                          }}
                        >
                          <Spin size="large" />
                        </div>
                      )}
                      <Image
                        src={img.ImageUrl}
                        alt={`product-${idx}`}
                        onLoad={handleImageLoad}
                        style={{
                          display: imageLoading ? "none" : "block",
                        }}
                      />
                    </div>
                  ))}
                </Carousel>

                <Row justify="center" style={{ marginTop: "12px" }}>
                  {productDet.ProductImages.map((img, idx) => (
                    <Col
                      key={idx}
                      style={{ margin: "0 4px", cursor: "pointer" }}
                    >
                      <Image
                        width={50}
                        src={img.ImageUrl}
                        preview={false}
                        onClick={() => handleThumbnailClick(idx)}
                        style={{
                          border:
                            currentSlide === idx
                              ? "2px solid #1890ff"
                              : "2px solid transparent",
                          borderRadius: 6,
                        }}
                      />
                    </Col>
                  ))}
                </Row>
              </Image.PreviewGroup>
            </Col>

            <Col xs={24} md={12}>
              {/* <Tag color="orange">AS SEEN ON TV</Tag> */}
              <Title level={3} style={{ margin: "12px 0" }}>
                {productDet.ProductName}
              </Title>
              <Tag
                ref={ref1}
                color={
                  statusColors[
                    showProdStatus
                      ? productDet.IsInStock === true
                        ? "Available"
                        : "Out of Stock"
                      : "General"
                  ]
                }
              >
                {showProdStatus
                  ? productDet.IsInStock === true
                    ? "Available"
                    : "Out of Stock"
                  : "Product Status"}
              </Tag>
              <h4>{productDet.DesignNo}</h4>

              {/* <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <Text strong>{product.rating}</Text>
            <StarFilled style={{ color: "#fadb14" }} />
            <Text type="secondary">({product.reviews} reviews)</Text>
            <img
              src="https://joj.com.in/images/jojlogo.png"
              alt="feefo"
              height={16}
            />
          </div> */}

              <Text type="secondary" style={{ display: "block", marginTop: 8 }}>
                {productDet.Detail ? productDet.Detail : productDet.Category}
              </Text>

              <div
                style={{
                  marginTop: 24,
                  background: "#fafafa",
                  padding: 6,
                  borderRadius: 12,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div>
                    {/* Show DealRate if present and less than SalesRate */}
                    {productDet.DealRate &&
                    productDet.DealRate > 0 &&
                    productDet.DealRate < productDet.SalesRate ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 12,
                        }}
                      >
                        <Title
                          level={4}
                          style={{
                            margin: 0,
                            color: "#888",
                            textDecoration: "line-through",
                            fontWeight: 400,
                          }}
                        >
                          ₹{productDet.SalesRate.toFixed(2)}
                        </Title>
                        <Title
                          level={2}
                          style={{ margin: 0, color: "#08979c" }}
                        >
                          ₹{productDet.DealRate.toFixed(2)}
                        </Title>
                      </div>
                    ) : (
                      <Title level={2} style={{ margin: 0, color: "#08979c" }}>
                        ₹{productDet.SalesRate?.toFixed(2)}
                      </Title>
                    )}

                    {/* Quantity and Add to Cart */}
                    {productDet.IsInStock === true && showOrderControls && (
                      <div style={{ marginTop: 16 }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 16,
                            marginBottom: 16,
                          }}
                        >
                          {/* Size Dropdown */}
                          <div>
                            <span style={{ marginRight: 8, fontWeight: 500 }}>
                              Size:
                            </span>
                            <Select
                              value={
                                typeof selectedSize === "object"
                                  ? selectedSize.Size
                                  : selectedSize
                              }
                              onChange={setSelectedSize}
                              style={{ width: 100 }}
                            >
                              {sizeOptions.map((size, idx) => (
                                <Select.Option
                                  key={
                                    typeof size === "object" ? size.Size : size
                                  }
                                  value={
                                    typeof size === "object" ? size.Size : size
                                  }
                                >
                                  {typeof size === "object" ? size.Size : size}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                          {/* Color Dropdown */}
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <span
                              style={{
                                marginRight: 8,
                                fontWeight: 500,
                              }}
                            >
                              Color:
                            </span>
                            {productDet.SellingSingleColor ? (
                              <Select
                                value={selectedColor}
                                open={colorDropdownOpen}
                                onDropdownVisibleChange={setColorDropdownOpen}
                                onChange={(value) => {
                                  setSelectedColor(value);
                                  const idx = colorOptions.findIndex(
                                    (img) => img.Description === value
                                  );
                                  if (idx !== -1) {
                                    setCurrentSlide(idx);
                                    carouselRef.current?.goTo(idx);
                                  }
                                  setColorDropdownOpen(false); // Close dropdown after selection
                                }}
                                style={{ width: 150 }}
                                dropdownRender={() => (
                                  <div>
                                    {colorOptions.map((img) => (
                                      <div
                                        key={img.Description}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          padding: "6px 12px",
                                          cursor: "pointer",
                                          background:
                                            selectedColor === img.Description
                                              ? "#e6f7ff"
                                              : "transparent",
                                        }}
                                        onClick={() => {
                                          setSelectedColor(img.Description);
                                          const idx = colorOptions.findIndex(
                                            (i) =>
                                              i.Description === img.Description
                                          );
                                          if (idx !== -1) {
                                            setCurrentSlide(idx);
                                            carouselRef.current?.goTo(idx);
                                          }
                                          setColorDropdownOpen(false); // Close dropdown after selection
                                        }}
                                      >
                                        <img
                                          src={img.ImageUrl}
                                          alt={img.Description}
                                          style={{
                                            width: 36,
                                            height: 36,
                                            objectFit: "cover",
                                            borderRadius: 4,
                                            marginRight: 12,
                                            border:
                                              selectedColor === img.Description
                                                ? "2px solid #1890ff"
                                                : "1px solid #eee",
                                          }}
                                        />
                                        <span>{img.Description}</span>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              >
                                {colorOptions.map((img) => (
                                  <Select.Option
                                    key={img.Description}
                                    value={img.Description}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <img
                                        src={img.ImageUrl}
                                        alt={img.Description}
                                        style={{
                                          width: 24,
                                          height: 24,
                                          objectFit: "cover",
                                          borderRadius: 3,
                                          marginRight: 8,
                                          border:
                                            selectedColor === img.Description
                                              ? "2px solid #1890ff"
                                              : "1px solid #eee",
                                        }}
                                      />
                                      <span>{img.Description}</span>
                                    </div>
                                  </Select.Option>
                                ))}
                              </Select>
                            ) : (
                              <Select
                                value="Mix Color"
                                style={{ width: 140 }}
                                disabled
                              >
                                <Select.Option value="Mix Color">
                                  Mix Color
                                </Select.Option>
                              </Select>
                            )}
                          </div>
                        </div>

                        <div style={{ marginBottom: 16 }}>
                          <span style={{ marginRight: 8, fontWeight: 500 }}>
                            Detail:
                          </span>
                          <Input
                            placeholder="Enter detail"
                            value={userDetail}
                            onChange={(e) => setUserDetail(e.target.value)}
                            style={{ width: 300 }}
                          />
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            marginTop: 8,
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <Button
                              onClick={() =>
                                setQuantity((q) => Math.max(1, q - 1))
                              }
                              style={{ minWidth: 32, padding: 0 }}
                              disabled={quantity <= 1}
                            >
                              -
                            </Button>
                            <span
                              style={{
                                fontSize: 12,
                                color: "#888",
                                marginTop: 2,
                              }}
                            >
                              &nbsp;
                            </span>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <InputNumber
                              min={1}
                              max={productDet.MaxQty || 100}
                              value={quantity}
                              onChange={setQuantity}
                              style={{
                                width: 40,
                                textAlign: "center", // This centers the text in the input
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                              controls={false}
                            />
                            <span
                              style={{
                                fontSize: 12,
                                color: "#888",
                                marginTop: 2,
                              }}
                            >
                              Box
                            </span>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <Button
                              onClick={() =>
                                setQuantity((q) =>
                                  Math.min(productDet.MaxQty || 100, q + 1)
                                )
                              }
                              style={{ minWidth: 32, padding: 0 }}
                              disabled={quantity >= (productDet.MaxQty || 100)}
                            >
                              +
                            </Button>
                            <span
                              style={{
                                fontSize: 12,
                                color: "#888",
                                marginTop: 2,
                              }}
                            >
                              &nbsp;
                            </span>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <Button
                              type="primary"
                              style={{ minWidth: 120, marginLeft: 16 }}
                              onClick={handleAddToCart}
                            >
                              Add to Cart
                            </Button>
                            <span
                              style={{
                                fontSize: 12,
                                color: "#888",
                                marginTop: 2,
                              }}
                            >
                              &nbsp;
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                    {/* Show total quantity below Add to Cart */}
                    {productDet.IsInStock === true && showOrderControls && (
                      <div
                        style={{
                          marginTop: 8,
                          marginLeft: 8,
                          fontSize: 14,
                          color: "#555",
                        }}
                      >
                        Total Quantity:{" "}
                        <b>
                          {quantity * (productDet.QtyInBox || 1)}{" "}
                          {productDet.Unit || ""}
                        </b>
                      </div>
                    )}
                  </div>
                  {/* <Button
                type="primary"
                size="large"
                style={{ background: "#fbb07c", border: 0 }}
              >
                Order Now
              </Button> */}
                </div>

                <div style={{ marginTop: 20 }}>
                  <Title level={5}>More Details</Title>
                  <List>
                    <List.Item ref={ref2}>
                      <CheckCircleOutlined
                        style={{ color: "#faad14", marginRight: 8 }}
                      />
                      {"Box Size : " +
                        productDet.QtyInBox +
                        " " +
                        productDet.Unit +
                        "(s)"}
                    </List.Item>

                    <List.Item ref={ref3}>
                      <CheckCircleOutlined
                        style={{ color: "#faad14", marginRight: 8 }}
                      />
                      {"Colors : " + productDet.NoOfColor}
                    </List.Item>
                    <List.Item>
                      <CheckCircleOutlined
                        style={{ color: "#faad14", marginRight: 8 }}
                      />
                      {"Selling Type : " +
                        (productDet.SellingSingleColor
                          ? "Individual Color"
                          : "Mix Colors")}
                    </List.Item>

                    <List.Item>
                      <CheckCircleOutlined
                        style={{ color: "#faad14", marginRight: 8 }}
                      />
                      {"HSN Code : " + productDet.HSN}
                    </List.Item>
                  </List>

                  {/* <Title level={5}>What’s included in the box?</Title>
              <List
                dataSource={product.included}
                renderItem={(item) => (
                  <List.Item>
                    <CheckCircleOutlined
                      style={{ color: "#faad14", marginRight: 8 }}
                    />
                    {item}
                  </List.Item>
                )}
              /> */}
                </div>
              </div>

              <div style={{ marginTop: 16 }}>
                <center>
                  <Tag
                    color="green"
                    style={{
                      fontSize: 14,
                      padding: "6px 12px",
                      width: "100%",
                      maxWidth: "300px",
                    }}
                  >
                    Confirm Final Availability with Sales Team <br />
                    <Button
                      ref={ref4}
                      type="primary"
                      icon={<WhatsAppOutlined />}
                      style={{
                        backgroundColor: "#25D366",
                        borderColor: "#25D366",
                        marginTop: 15,
                        marginBottom: 8,
                        width: "100%", // Default to full width
                        maxWidth: "300px", // Limit width for larger screens
                        height: 40,
                        fontSize: 16,
                      }}
                      onClick={handleWhatsAppClick}
                    >
                      Check Availability via WhatsApp
                    </Button>
                  </Tag>
                </center>
              </div>
            </Col>
          </Row>
          <Tour
            open={open}
            mask={false}
            onFinish={() => logTourStatus({ IsCompleted: true, IsSkip: false })}
            onClose={() => {
              setOpen(false);
              logTourStatus({ IsCompleted: false, IsSkip: true });
            }}
            steps={steps}
            styles={{
              popover: {
                background: "#fffbe6", // Try a more visible color, e.g. light yellow
                color: "#333",
                zIndex: 2000,
              },
              title: {
                color: "#1677ff",
              },
              description: {
                color: "#333",
              },
            }}
          />
        </div>
      )}
    </>
  );
};

export default ProductDetail;
